export default "__VITE_ASSET__GejPLCsf__"